import { render, staticRenderFns } from "./crudPointsSales.vue?vue&type=template&id=e578c114&scoped=true&"
import script from "./crudPointsSales.vue?vue&type=script&lang=js&"
export * from "./crudPointsSales.vue?vue&type=script&lang=js&"
import style0 from "./crudPointsSales.vue?vue&type=style&index=0&id=e578c114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e578c114",
  null
  
)

export default component.exports